import React, { ChangeEvent, FocusEventHandler, useEffect, useState } from "react"
import clsx from "clsx"

import DateField from "@ecom/ui/components/DateField/ZeroPaddedDateField"

import { FormikTouched } from "formik"
import pushToDataLayer from "@ecom/ui/utils/pushToDataLayer"
import { WrapperDataLayer } from "./WrapperDataLayer"
import * as styles from "./fields.module.scss"

type Props = {
  id: string
  name: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  handleBlur: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
  error?: string
  touched?: FormikTouched<{}>
  value?: string
  inputsColor?: "white" | "grey"
  placement?: string
}

const maxValidYear = String(new Date().getFullYear())

export const BirthField = ({
  touched,
  error,
  handleBlur,
  name,
  value,
  inputsColor = "white",
  onChange,
  placement = "main",
  ...restProps
}: Props) => {
  const onChangeDate = (event: ChangeEvent<HTMLInputElement>) => {
    const [day, month, year] = event.target.value.split(".")

    let newValue = event.target.value

    if (year) {
      const indexLastSymbol = year.length - 1
      const lastSymbolYear = year[indexLastSymbol]
      const lastSymbolValidYear = maxValidYear[indexLastSymbol]
      const slicedValidYear = maxValidYear.slice(0, indexLastSymbol)

      if (year > slicedValidYear && lastSymbolYear > lastSymbolValidYear) {
        const newValidValueYear = year.slice(0, indexLastSymbol) + lastSymbolValidYear
        newValue = `${day}.${month}.${newValidValueYear}`
      }
    }

    const customEvent = {
      target: {
        name,
        value: newValue,
      },
    } as ChangeEvent<HTMLInputElement>

    onChange(customEvent)
  }

  const [isChanged, setIsChanged] = useState(false)

  const handleFocus = () => {
    pushToDataLayer({
      event: "GAFormEvent",
      eventCategory: "fieldFocused",
      eventAction: name,
      eventLabel: globalThis?.location?.href,
      placement,
    })
  }

  useEffect(() => {
    if (value !== "") {
      setIsChanged(true)
    }
  }, [value])

  const customHandleBlur = (e: any) => {
    if (isChanged) {
      handleBlur(e)
    }
  }

  return (
    <WrapperDataLayer
      isChanged={isChanged}
      touched={touched}
      error={touched ? error || "" : ""}
      name={name}
    >
      <div className={styles.fieldWrapper}>
        <DateField
          onInput={onChangeDate}
          {...restProps}
          InputProps={{
            classes: {
              notchedOutline: styles.notchedOutline,
              root: clsx(styles.field, styles[inputsColor]),
            },
          }}
          onFocus={handleFocus}
          value={value}
          onBlur={customHandleBlur}
          helperText={touched ? error : ""}
          error={touched && !!error}
          fullWidth
          max={new Date()}
          validAgeMin={18}
          validAgeMax={85}
          placeholder="Дата рождения"
        />
      </div>
    </WrapperDataLayer>
  )
}
